<template>
  <header :class="{ scrolled }" class="header">
    <router-link to="/dashboard" >
      <logo :height="30" navy/>
    </router-link>
    <div class="languages">
      <button :class="{ 'active': isActiveLang('pl') }" class="lang pl" @click="setLanguage('pl')">PL</button>
      <!-- <button :class="{ 'active': isActiveLang('en') }" class="lang en" @click="setLanguage('en')">EN</button>-->
      <button :class="{ 'active': isActiveLang('cs') }" class="lang cz" @click="setLanguage('cs')">CZ</button>
    </div>
  </header>
</template>

<script>
import Logo from '@/components/Logo'
import { mapActions, mapGetters } from 'vuex'

export default {
  components: {
    Logo
  },
  data () {
    return {
      topPosition: 0
    }
  },
  computed: {
    ...mapGetters(['isActiveLang']),
    scrolled () {
      return this.topPosition > 100
    }
  },
  created () {
    this.setLanguage(this.$i18n.locale)
  },
  mounted () {
    const scrollHandler = () => { this.topPosition = window.scrollY }

    window.addEventListener('scroll', scrollHandler)

    this.$once('hook:beforeDestroy', () => { window.removeEventListener('scroll', scrollHandler) })
  },
  methods: {
    ...mapActions(['setLanguage'])
  }
}
</script>

<style lang="scss" scoped>
  .header {
    position: fixed;
    z-index: 1000;
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 70px;
    margin: 0 auto;
    padding: 0 20px;
    background: #fff;
    transition: $time;
  }

  .scrolled {
    box-shadow: $box-shadow;
  }

  .languages {
    display: flex;
    height: 100%;
  }

  .lang {
    margin: 0 20px 0 0;
    padding: 5px 0;
    border: none;
    outline: none;
    color: black;
    text-decoration: none;
    font-weight: 500;
    font-size: 16px;
    cursor: pointer;
    background-color: transparent;
    border-bottom: 1.5px solid transparent;

    &:last-child {
      margin: 0;
    }

    &.active {
      color: $navy;
      border-color: $navy;
    }
  }
</style>
